(() => {
  const root = document.querySelector('.sf-wholesale-application');
  if (!root) return;

  const enhanceAbnFields = () => {
    root.querySelectorAll('label').forEach((label) => {
      if (!/^\s*abn\b.*\b11\b/i.test(label.textContent || '')) return;

      const wrapper = label.closest('.formful__field-wrapper, .field, div');
      const input = wrapper?.querySelector('input') || (label.htmlFor ? document.getElementById(label.htmlFor) : null);
      if (!input || input.type !== 'text' || input.dataset.sfAbnEnhanced === 'true') return;

      input.dataset.sfAbnEnhanced = 'true';
      input.inputMode = 'numeric';
      input.pattern = '[0-9 ]{11,14}';
      input.minLength = 11;
      input.maxLength = 14;

      const validate = () => {
        const digits = input.value.replace(/\s/g, '');
        const valid = /^\d{11}$/.test(digits);
        input.setCustomValidity(input.value && !valid ? 'Enter a valid 11-digit ABN.' : '');
      };

      input.addEventListener('input', validate);
      input.addEventListener('blur', validate);
      validate();
    });
  };

  enhanceAbnFields();
  new MutationObserver(enhanceAbnFields).observe(root, { childList: true, subtree: true });
})();
